import { useQuery } from '@apollo/react-hooks';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';
import { getAtlassianPeopleProfileUrl } from '@confluence/profile';

import { UserAvatarDataQuery } from '../../graphql/UserAvatarDataQuery.graphql';

const CONTEXT_PATH = '/wiki';

export const useGetUserAvatarData = () => {
	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		UserAvatarDataQuery,
		{
			fetchPolicy: 'cache-and-network',
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	const userAvatarData = data?.searchUser?.nodes.reduce((filteredData: any, node: any) => {
		const user = node.user;
		const accountType = user?.accountType;

		if (accountType === 'app') return filteredData;

		const filteredUser = {
			name: user?.displayName ?? '',
			src: user?.profilePicture?.path,
			userId: user?.accountId,
			href: getAtlassianPeopleProfileUrl(user?.accountId, null, CONTEXT_PATH),
		};
		filteredData.push(filteredUser);
		return filteredData;
	}, []);

	return {
		error,
		loading,
		userAvatarData,
	};
};
